import React from 'react';
import { SimpleSailing, SimpleSailingDay } from '@go-shared/types/sailing';
import { range } from '@go-shared/lib/functional';
import { CalendarView } from './CalendarView';
import { WEEK_DAYS } from '@go-shared/lib/time';
import { MonthSelector } from './MonthSelector/MonthSelector';
import { Dropdown } from '@spark-labs/avocado-ui';
import { BubbleButton, BubbleOverlay } from '../BubbleUI';
import ItineraryNavigation from '../Navigations/ItineraryNavigation';

export interface CalendarViewWrapperProps {
  loading: boolean;
  sailings: SimpleSailing[];
  selectedMonth: number;
  onRundownClick: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
  onContentBuilderClick: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
  onSailingDayLock: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
  onSailingDayStar: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
  onSailingDayTemplateClick: (sailing: SimpleSailing, sailingDay: SimpleSailingDay) => void;
  onMonthChanged: (newMonth: number) => void;
  onYearChanged: (selectedYear: number) => void;
  selectedYear: number;
}

const COLUMNS = WEEK_DAYS.map(day => day.substring(0, 3));
const COLUMN_WIDTH = 100 / WEEK_DAYS.length;

export default function CalendarViewWrapper(props: CalendarViewWrapperProps) {
  const {
    loading,
    sailings,
    selectedMonth,
    onRundownClick,
    onContentBuilderClick,
    onMonthChanged,
    onSailingDayLock,
    onSailingDayStar,
    onSailingDayTemplateClick,
    onYearChanged,
    selectedYear,
  } = props;

  return (
    <>
      <div
        className="ItineraryHeader align-with-logo flex items-end
      px-5 sticky top-0 left-0 z-10 bg-blue-lightest"
      >
        <div className="mb-3 pl-3 flex-grow flex items-end">
          <ItineraryNavigation active="itinerary" />
          <div className="ml-auto flex items-center space-x-2">
            <MonthSelector onMonthChanged={onMonthChanged} month={selectedMonth} />
            <Dropdown
              alignRight
              onSelect={item => onYearChanged(item.element as any)}
              items={[
                { element: 2023, key: 2023 },
                { element: 2024, key: 2024 },
                { element: 2025, key: 2025 },
              ]}
            >
              {({ toggleRef, ...rest }) => (
                <BubbleButton
                  variant="white"
                  className="shadow-sm"
                  iconSuffix="caret-down"
                  buttonRef={toggleRef}
                  {...rest}
                >
                  {selectedYear}
                </BubbleButton>
              )}
            </Dropdown>
          </div>
        </div>
      </div>
      <div className="ItineraryBody mx-5 content-minus-logo min-w-900">
        <div className="shadow">
          <table className="w-full sticky z-10" style={{ top: '130px' }}>
            <thead>
              <tr>
                {range(COLUMNS.length).map(i => (
                  <th
                    key={i}
                    className="p-4 bg-navy text-white uppercase"
                    style={{ width: COLUMN_WIDTH + '%' }}
                  >
                    {COLUMNS[i]}
                  </th>
                ))}
              </tr>
            </thead>
          </table>
          <BubbleOverlay opacity={100} loading={loading} style={{ minHeight: '100px' }}>
            <CalendarView
              selectedMonth={selectedMonth}
              sailings={sailings}
              onRundownClick={onRundownClick}
              onContentBuilderClick={onContentBuilderClick}
              onSailingDayLock={onSailingDayLock}
              onSailingDayStar={onSailingDayStar}
              onSailingDayTemplateClick={onSailingDayTemplateClick}
            />
          </BubbleOverlay>
        </div>
        <div className="mt-3">&nbsp;</div>
      </div>
    </>
  );
}
